import { z } from "zod";

import { Command } from "../../types";

export const generateInviteLinkSchema = z.object({
  command: z.literal(Command.GenerateInviteLink),
});

export type GenerateInviteLinkValues = z.infer<typeof generateInviteLinkSchema>;
